
    <mat-card class="no-overflow full-width margin all padding all">
      <div class="row no-overflow fill">
        <!-- Hierarchy Side Bar -->
        <div
          id="hierarchySideBar"
          class="hierarchy-side-bar"
          (click)="autoSet('hierarchySideBar', hierarchySideBar.width)"
        >
            <lib-hierarchy
              *ngIf="keyingDataSets?.masterKeysKeying"
              [masterKeys]="keyingDataSets?.masterKeysKeying"
              [keySystem]="keyingDataSets?.keySystem"
              [selectedMasterKey]="selectedMasterKey"
              [onlyTree]="true"
              (selectKey)="selectMasterKey($event)"
              (deleteItemAction)="deleteItem($event)"
              (deleteChildrenAction)="deleteChildren($event)"
              (patchItemAction)="patchItem($event)"
              (addChildAction)="addChild($event)"
              [@fadeIn]
            >
            </lib-hierarchy>
        </div>

        <div class="col no-overflow full-width border">
          <!-- Selected Master Key Header -->
          <div *ngIf="selectedMasterKey" [flex]="0" class="row master-key-header center bottom-border">
            <div
              class="master-key lrg"
              [@fadeIn]
              [ngClass]="{
                'change-key':
                  selectedMasterKey?.isChangeKey ||
                  selectedMasterKey?.masterKeyType?.name === 'ChangeKey' ||
                  selectedMasterKey?.masterKeyType?.name === 'Direct',
                skd:
                  selectedMasterKey?.masterKeyType?.name === 'SingleKeyDifferentMaster' ||
                  selectedMasterKey?.masterKeyType?.name === 'SingleKeyDifferent',
                slm: selectedMasterKey?.masterKeyType?.name === 'SelectiveMaster',
                dc: selectedMasterKey?.masterKeyType?.name === 'DirectMaster'
              }"
            >
              {{ selectedMasterKey?.keySetSymbol }}
            </div>

            <!-- Breadcrumbs -->
            <div class="row three-quarters-width" *ngIf="selectedTab?.id === 0">
              <div>/</div>
              <div class="custom link margin left min-width-fifty" matTooltip="Library" [ngClass]="{ bold: selectedBook }" (click)="goToLibrary()">
                Library
              </div>
              <div class="margin left right" *ngIf="selectedBook">/</div>
              <!-- <div *ngIf="selectedBook" class="custom lrg padding sm right" [matTooltip]="selectedBook.bookNumber">Book {{ selectedBook.bookNumber }}:</div> -->
              <div *ngIf="selectedBook" class="custom lrg" [matTooltip]="selectedBook.assignmentString">
               Book {{ selectedBook.bookNumber }}: {{ selectedBook.assignmentString }}
              </div>
            </div>

            <div class="row" *ngIf="selectedTab?.id === 1">
              <div>/</div>
              <div class="custom link margin left" [ngClass]="{ bold: selectedCylinder }" (click)="goToCylLibrary()">
                Cylinders
              </div>
              <div class="margin left right" *ngIf="selectedCylinder">/</div>
              <div *ngIf="selectedCylinder" class="custom lrg">
                {{ selectedCylinder.name }}
              </div>
            </div>

            <div class="row fixed-row flex-end">
              <mat-tab-group
                class="tabs white-background"
                mat-stretch-tabs
                [(selectedIndex)]="selectedTabIndex"
                (selectedTabChange)="onChangeTab($event)"
              >
                <mat-tab *ngFor="let tab of tabs; trackBy: trackTab" [label]="tab.name"></mat-tab>
              </mat-tab-group>
              <!-- <mat-tab-group (selectedTabChange)="onChangeTab($event)">
                <mat-tab *ngFor="let tab of tabs"
                  class="tabs">
                  <ng-template mat-tab-label>{{tab.name}}</ng-template>
                </mat-tab>
              </mat-tab-group> -->
            </div>
          </div>

          <div class="row no-overflow fill">
            <!-- Matrix -->
            <app-matrix
              [structure]="structure"
              [mkSideBar]="mkSideBar"
              [selectedMasterKey]="selectedMasterKey"
              [library]="library"
              [selectedTab]="selectedTab"
              [keySystem]="keySystem"
              [selectedBook]="selectedBook"
              [assignedMasterKeyBittings]="assignedMasterKeyBittings"
              [selectedCylinder]="selectedCylinder"
              (finished)="resetBook()"
              (requestChanged)="updateRequest($event)"
              (validate)="validateCylinder()"
              (bookWritten)="library = $event"
              (addKey)="onAddKey($event)"
              (removeKey)="onRemoveKey($event)"
              [enablePrepareForMECS]="enablePrepareForMECS"
            >
            </app-matrix>

            <!-- Library -->
            <div class="col no-overflow flex-2">
              <!-- Assign Bittings Tool Bar -->
              <div
                *ngIf="selectedBook && selectedTab?.id === 0"
                class="row tool-bar"
                [justify]="'center'"
                [@slideInOnlyDown]
              >
                <!-- <phx-col [justify]="'center'" [padding]="8">
                  <phx-row class="center">
                    <div class="custom">Total Combinations:</div>
                    <div class="caption padding sm left">
                      {{selectedBook?.stats?.total}}
                    </div>
                  </phx-row>
                </phx-col> -->
                <div [justify]="'center'" class="col">
                  <div [justify]="'space-between'" class="row center">
                    <!-- Key list filter options -->
                    <div style="display: flex; align-items: center">
                      <button mat-icon-button [matMenuTriggerFor]="actions">
                        <mat-icon>filter_list_outline</mat-icon>
                      </button>
                      <div class="margin right">/</div>
                      <!-- <lib-key *ngIf="selectedFilterKey?.id" [hierarchyItem]="selectedFilterKey"></lib-key> -->
                      <div *ngIf="selectedFilterKey?.id" class="custom lrg">{{ selectedFilterKey?.keySetSymbol }}</div>
                      <div *ngIf="!selectedFilterKey?.id" class="custom lrg">{{ selectedFilterKey }}</div>
                    </div>

                    <div style="display: flex; align-items: center" class="fixed-row">
                      <mat-menu #actions>
                        <button mat-menu-item (click)="clearFilter()"><mat-icon>rule</mat-icon>Show All</button>
                        <button mat-menu-item (click)="filterKeyListUnassigned()">
                          <mat-icon>format_list_bulleted</mat-icon>Unassigned
                        </button>

                        <button
                          mat-menu-item
                          (click)="filterKeyList(crossKey)"
                          *ngFor="let crossKey of selectedMasterKey.crossKeyAssignments"
                        >
                          <mat-icon
                            matTooltipShowDelay="400"
                            matTooltip="Key is a Cross Key Operator"
                            class="padding margin right"
                            [size]="24"
                          >key</mat-icon
                          >{{ crossKey.keySetSymbol }} Operators
                        </button>
                      </mat-menu>

                      <!-- <phx-button
                        (document:keydown.shift.u)="hotkey('u')"
                        (click)="unassignKbas()"
                        [outline]="true"
                        [small]="true"
                        class="margin left"
                      >
                        Unassign
                      </phx-button> -->
                      <button
                        mat-stroked-button
                        (document:keydown.shift.u)="hotkey('u')"
                        (click)="unassignKbas()"
                        class="margin all darkenBorder"
                      >
                        Unassign
                      </button>

                      <!-- <phx-button
                        [color]="'#393E46'"
                        (document:keydown.shift.a)="hotkey('a')"
                        (click)="assignKbas()"
                        [outline]="false"
                        [small]="true"
                        class="margin left"
                      >
                        Assign
                      </phx-button> -->

                      <button
                        mat-stroked-button
                        (document:keydown.shift.a)="hotkey('a')"
                        (click)="assignKbas()"
                        class="margin left darkBackground"
                      >
                        Assign
                      </button>

                      <button mat-icon-button [matMenuTriggerFor]="actionsMore">
                        <mat-icon>more_vert</mat-icon>
                      </button>

                      <mat-menu #actionsMore>
                        <button mat-menu-item (document:keydown.shift.g)="hotkey('g')" (click)="assignKbas(false)">
                          <mat-icon>warning_outline</mat-icon>Assign + Guideline Violators
                        </button>
                        <button
                          mat-menu-item
                          [disabled]="selectedKbaArray.length === 0"
                          (document:keydown.shift.r)="hotkey('r')"
                          (click)="
                            openDialog(1, {
                              masterkeys: this.selectedMasterKey.children,
                              selectedKbaArray: this.selectedKbaArray,
                              selectedMasterKey: this.selectedMasterKey,
                              reservationTypes: this.reservationTypes
                            })
                          "
                        >
                          <mat-icon>lock_outline</mat-icon>Reserve
                        </button>

                        <ng-container *featureFlag="'MOVE_BITTINGS'">
                          <button
                            mat-menu-item
                            [disabled]="selectedForMoveBittings.length === 0"
                            (click)="openMoveBittingsDialog()"
                          >
                            <mat-icon>drive_file_move_outline</mat-icon>Move Bittings
                          </button>
                        </ng-container>
                      </mat-menu>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Cylinders Tool Bar -->
              <div *ngIf="selectedTab?.id === 1 && false" class="row tool-bar" [justify]="'center'" [@slideInOnlyDown]>
                <div [justify]="'center'" class="col padding all">
                  <div class="row center">
                    <div class="custom">Operated By</div>
                  </div>
                </div>
                <div [justify]="'center'" class="col">
                  <div [justify]="'flex-end'" class="row center">
                    <!-- <phx-button [outline]="true" [small]="true" class="margin left">
                      Make a new Cylender!
                    </phx-button> -->
                    <button mat-flat-button [outline]="false" [small]="true" class="margin left gray700">
                      Make a new Cylinder!
                    </button>
                    <button mat-icon-button aria-label="">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Libraries -->
              <app-key-bitting-library
                *ngIf="selectedTab?.id === 0"
                [library]="library"
                [selectedMasterKey]="selectedMasterKey"
                [selectedFilterKey]="selectedFilterKey"
                [selectedBook]="selectedBook"
                [keySystem]="keySystem"
                [structure]="structure"
                [reservationTypes]="reservationTypes"
                [assignedMasterKeyBittings]="assignedMasterKeyBittings"
                (updateAssignedMasterKeyBittings)="setAssignedMasterKeyBittings($event)"
                (splitMasterKeyBitting)="splitMasterKeyBitting($event)"
                (selectedKbas)="selectedKbas($event)"
                (resetBook)="reloadBook()"
                (selectedForMoveChanged)="onSelectedForMoveChanged($event)"
              >
              </app-key-bitting-library>

              <app-cylinder-library
                *ngIf="selectedTab?.id === 1"
                [cylinderValidation]="cylinderValidation"
                [cylinderNav]="cylinderNav"
                (selectedCylinderUpdate)="selectCylinder($event)"
                [hasControlKeyMaster]="hasControlKeyMaster"
                (prepareForMECS)="prepareForMECSHandler()"
                [selectedTabId]="selectedTab?.id"
              >
              </app-cylinder-library>

              <app-construction-key-library *ngIf="selectedTab?.id === 2"> </app-construction-key-library>

              <!-- Footer -->
              <div class="row footer padding all"> </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card>

